import SmoothScroll from 'smooth-scroll'
import Accordion from './lib/accordion'
import Splide from '@splidejs/splide'

/* -------------------------------------------------------------------
  utility
------------------------------------------------------------------- */
const smoothScroll = new SmoothScroll('a[href*="#"]', {
  speed: 500,
  speedAsDuration: true,
  popstate: true,
  updateURL: false,
  offset: (anchor, toggle) => {
    if(toggle.href == '#'){
      return 0
    }else{
      const headerHeight = document.querySelector('.header') ?
        document.querySelector('.header').offsetHeight : 0;
      return headerHeight
    }
  }
})

Accordion()

// const splide = new Splide( '.splide' );
// splide.mount();

const cvp = document.querySelector('.cvp')
const cvpObserver = new IntersectionObserver(entries => {
  for (const entry of entries) {
    if (entry.isIntersecting === false) {
      cvp.classList.add('--sticky')
    } else {
      cvp.classList.remove('--sticky')
    }
  }
});
// cvpObserver.observe(document.querySelector('.footer'))
cvpObserver.observe(document.querySelector('.fv'))


const animateObserver = new IntersectionObserver(entries => {
  for (const entry of entries) {
    if (entry.isIntersecting === true) {
      entry.target.classList.add('--animated')
    }
  }
});

const jsFadeIn = document.querySelectorAll('.js-fade-in');
jsFadeIn.forEach(el => animateObserver.observe(el))

const jsFadeUp = document.querySelectorAll('.js-fade-up');
jsFadeUp.forEach(el => animateObserver.observe(el))
